module.exports = __webpack_public_path__ + "assets/img/11_466_big.0af224ee.jpg";